
import { Route } from '@/entity/route'
import router from '@/router'
import Vue from 'vue'

export default Vue.extend({
  name: 'Search',
  data: function () {
    return {
      listLink: Route.MenuList.path,
      genreLink: Route.SearchByGenre.path,
      methodLink: Route.SearchByMethod.path,
      ingredientLink: Route.SearchByIngredient.path,
      newMenuLink: Route.NewMenu.path,
      keyword: ''
    }
  },
  methods: {
    submitToSearchKeyword: function () {
      if (this.keyword === '') {
        alert('検索したいキーワードを入力してください。')
        return
      }
      router.push(Route.SearchByKeyword.getPath(this.keyword))
    }
  }
})
